import { render, staticRenderFns } from "./forwarding.vue?vue&type=template&id=c2cdef8c&scoped=true&"
import script from "./forwarding.vue?vue&type=script&lang=js&"
export * from "./forwarding.vue?vue&type=script&lang=js&"
import style0 from "./forwarding.vue?vue&type=style&index=0&id=c2cdef8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cdef8c",
  null
  
)

export default component.exports